export default "__VITE_ASSET__BEkRvo68__"